// extracted by mini-css-extract-plugin
module.exports = {"root":"banner-description_root__wsKsw"};